<template>
  <div class="exhibitions">
    <h1>Alle Projekte</h1>
    <div class="exhibitions-flex" v-if="exhibitionsLoaded">
      <div class="exhibition"
           v-for="exhibition in exhibitions"
           :key="exhibition.id"
           @click="goTo(exhibition.id)">
        <div class="img" v-if="exhibition.name  === 'Sichtraum'">
          <img class="sichtraum" alt="" src="/assets/sichtraum2020.svg">
        </div>
        <div class="overlay">
          <div class="status">
            <span class="ficon" v-if="exhibition.name  === 'Sichtraum'">
              
            </span>
          </div>
          <div class="exhibition__title">
            <div class="exhibition__name">
              {{ exhibition.name }}
            </div>
            <div class="exhibition__location">
              {{ exhibition.location }}
            </div>
          </div>
          <div class="dates">
            <div class="dateLayout">
              <div>
                <div class="time">
                  {{ exhibition.start.getHours() + ':'
                  + (exhibition.start.getMinutes() &lt; 10 ? '0' : '' )
                  + exhibition.start.getMinutes() }}
                </div>
                <div class="date">
                  {{ exhibition.start.getDate() + '.'
                  + exhibition.start.getMonth() + '.'
                  + exhibition.start.getFullYear()
                  }}
                </div>
              </div>
              <div class="chevron">
                <span class="ficon"></span>
              </div>
              <div>
                <div class="time">
                  {{ exhibition.end.getHours() + ':'
                  + (exhibition.end.getMinutes() &lt; 10 ? '0' : '' )
                  + exhibition.end.getMinutes() }}
                </div>
                <div class="date">
                  {{ exhibition.end.getDate() + '.'
                  + exhibition.end.getMonth() + '.'
                  + exhibition.end.getFullYear()
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import gql from 'graphql-tag';
// import { print } from 'graphql';
// import axios from 'axios';

export default {
  name: 'Exhibitions',
  computed: {
    exhibitions() {
      return this.$store.state.exhibitions;
    },
    exhibitionsLoaded() {
      return this.$store.state.exhibitionsLoaded;
    },
  },
  mounted() {
    // axios({
    //   url: 'https://theia.informatik.hs-augsburg.de:3030/graphql',
    //   method: 'post',
    //   data: {
    //     query: print(
    //       gql`query {
    //           exhibitions {
    //             id: _id
    //             name
    //             start
    //             end
    //             rooms
    //             location
    //           }
    //         }
    //         `,
    //     ),
    //   },
    //   headers: {
    //     theia: '83UcD&mA%Sr&%q',
    //   },
    // })
    //   .then((result) => {
    //     console.log(result.data);
    //     this.$store.state.exhibitions = [];
    //     result.data.data.exhibitions.forEach((exhibition) => {
    //       const convertedResult = {
    //         id: exhibition.id,
    //         location: exhibition.location,
    //         name: exhibition.name,
    //         start: this.parseISOString(exhibition.start),
    //         end: this.parseISOString(exhibition.end),
    //         rooms: exhibition.rooms,
    //       };
    //       console.log(convertedResult.location);
    //       this.$store.state.exhibitions.push(convertedResult);
    //       this.$store.state.exhibitionsLoaded = true;
    //     });
    //   });
  },
  methods: {
    goTo(id) {
      this.$store.state.selectedExhibition = id;
      const exhibition = this.exhibitions.find((e) => e.id === id);
      this.$store.state.focusAStart = exhibition.start;
      this.$store.state.focusAEnd = exhibition.end;
      // this.$loading(true);
      document.getElementById('loading').classList.remove('hide');
      setTimeout(() => {
        this.$router.push(`project/${id}`);
      }, 400);
    },
    parseISOString(s) {
      const b = s.split(/\D+/);
      return new Date(Date.UTC(b[0], b[1] - 1, b[2], b[3], b[4], b[5], b[6]));
    },
  },
};
</script>

<style scoped lang='scss'>
  @import "../assets/scss/theme";

  .exhibitions {
    width: 100%;
    a {
      text-decoration: none;
      color: $black100;
    }
  }

  .exhibitions-flex {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    @media (min-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 992px) and (max-width: 1199.98px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 991.98px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .exhibition {
    position: relative;
    height: 14rem;
    background: $creme100;
    border-radius: 4px;
    margin: 0 1rem 1rem 0;
    padding: 1rem;
    cursor: pointer;
    font-family: "Hind Madurai", sans-serif;
    font-weight: $font-weight-semi-bold;
    font-size: 1.5rem;
    overflow: hidden;
    transition: .25s ease-in-out;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);

    @media (max-width: 991.98px) {
      height: 10rem;
    }

    &:hover {
      background: $orange100;
      transform: scale(1.025);
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

      .exhibition {

        &__name {
          background: $orange100;
          color: $white;
        }
        &__location {
          background: $orange100;
          color: $white;
        }
      }

      .time, .date, .ficon {
        color: $white;
      }
    }

    &__title {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    &__name {
      background: $creme100;
      border-radius: 4px;
      padding: 0;
      transition: .25s ease-in-out;
    }

    &__location {
      background: $creme100;
      border-radius: 4px;
      font-weight: $font-weight-regular;
      font-size: 1rem;
      transition: .25s ease-in-out;
    }

    .img {
      /*max-height: 5rem;*/
      position: absolute;
      /*width: 100%;*/
      /*height: 100%;*/
      overflow: hidden;
      margin: -1rem;
      /*margin-left: 0;*/
      /*margin-right: 0;*/
      z-index: 1000;

      .sichtraum {
        max-width: 10rem;
        margin-left: -20px;

        @media (max-width: 767.98px) {
          /*opacity: .25;*/
          max-width: 8rem;
        }
      }
    }

    .overlay {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      z-index: 1020;
    }

    .status {
      min-height: 3rem;
      display: flex;
      justify-content: flex-end;
      margin-right: 0;
      align-items: flex-start;
      width: 100%;

      .ficon {
        font-size: 3rem;
        font-weight: $font-weight-regular;
        line-height: 1rem;
        color: $orange100;
      }
    }

    .dates {
      font-weight: $font-weight-regular;
      font-size: .8rem;
      width: 100%;
      min-height: 3rem;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      transition: .25s ease-in-out;

      .dateLayout {
        text-align: right;
        display: flex;

        >div {
          margin-left: 1rem;
        }

        .chevron {
          display: flex;
          align-items: center;
          transition: .25s ease-in-out;

          .ficon {
            transition: .25s ease-in-out;
          }
        }

        .time, .date {
          transition: .25s ease-in-out;
        }
      }
    }
  }
</style>
